module.exports = __webpack_public_path__ + "img/anemos.2454687e.jpg";